document.addEventListener("DOMContentLoaded", function () {
  imageWScale(".co-faq-section-1-image", "top 100");
  imageWScale(".co-contact-section-1-image", "top 100");
  imageWScale(".co-home-section-4-image", "top 100");
  // imageWScale(".co-home-section-1--wrapper", "top 100");

  //Menu Tabs
  var coMenuItems = document.querySelectorAll(".co-menu-section-2--title");
  var coMenuDescs = document.querySelectorAll(".co-menu-section-2--desc");
  // Hide the next sibling element for each item (the content associated with the title)
  coMenuItems.forEach(function (menuItem, index) {
    var nextElement = menuItem.nextElementSibling;
    if (index === 0 || menuItem.classList.contains("active")) {
      menuItem.classList.add("active");
      coMenuDescs[index].classList.add("active");
      // nextElement.classList.add("active");

      gsap.to(coMenuDescs[index], {
        // height: "auto",
        opacity: 1,
        xPercent: 0,
        duration: 0.5,
        ease: "power2.inOut",
      });
    } else {
      // nextElement.classList.remove("active");
      coMenuDescs[index].classList.remove("active");
      gsap.to(coMenuDescs[index], {
        // height: 0,
        opacity: 0,
        xPercent: -5,
        duration: 0.5,
        ease: "power2.inOut",
      });
    }

    // Add a click event listener to each item
    menuItem.addEventListener("click", function (e) {
      e.preventDefault();
      document.getElementById("evenhouse-menu").scrollIntoView();
      // Check if the parent element already has the 'active' class
      if (!this.classList.contains("active")) {
        // If not active, hide all other sections
        coMenuItems.forEach(function (otherMenuItem, otherIndex) {
          otherMenuItem.classList.remove("active");
          // otherMenuItem.nextElementSibling.classList.remove("active");
          coMenuDescs[otherIndex].classList.remove("active");

          gsap.to(coMenuDescs[otherIndex], {
            // height: 0,
            opacity: 0,
            xPercent: -5,
            duration: 0.5,
            ease: "power2.inOut",
          });
        });
        // Add 'active' class to the clicked item and show its content
        this.classList.add("active");
        coMenuDescs[index].classList.add("active");
        gsap.to(coMenuDescs[index], {
          // height: "auto",
          opacity: 1,
          xPercent: 0,
          duration: 0.5,
          ease: "power2.inOut",
        });
      }
      // If already active, don't hide the content
    });
  });
});

document.addEventListener("scroll", function () {
  let header = document.querySelector(".header-wrapper");
  let logoPreload = document.querySelector(".header_preload");
  let topOffset = header.getBoundingClientRect().top;

  let offset = 0;

  if (window.scrollY > 0) {
    header.classList.add("header--fixed");
  } else {
    header.classList.remove("header--fixed");
  }

  if (logoPreload) {
    let offset = 150;

    if (window.matchMedia("(max-width: 1024px)").matches) {
      offset = 50;
    }
    if (topOffset <= offset) {
      logoPreload.classList.add("is-hidden");
      header.classList.add("scrolled-past");
    } else {
      logoPreload.classList.remove("is-hidden");
      header.classList.remove("scrolled-past");
    }
  }
});

function imageWScale(imageQ, start) {
  let image = document.querySelectorAll(imageQ);
  image.forEach(function (imageItem, index) {
    const growTl = gsap.timeline({
      scrollTrigger: {
        trigger: imageItem,
        scrub: 1.5,
        start: start,
        end: "+=400",
        ease: "power1.out",
      },
    });
    growTl.to(imageItem, {
      duration: 0.8,
      width: "100%",
    });
  });
}

function imageRadius(imageQ, start) {
  let image = document.querySelectorAll(imageQ);
  image.forEach(function (imageItem, index) {
    const growTl = gsap.timeline({
      scrollTrigger: {
        trigger: imageItem,
        scrub: 1.5,
        start: start,
        end: "+=400",
        ease: "power1.out",
      },
    });
    growTl.to(imageItem, {
      duration: 0.5,
      borderRadius: 0,
    });
  });
}
